import Vue from "vue";
import VueRouter from "vue-router";
import SurveyPage from "../views/SurveyPage/SurveyPage";
import SubmittedSurveyPage from "../views/SurveyPage/SubmittedSurveyPage";
Vue.use(VueRouter);

const routes = [
  {
    path: "/submitted",
    name: "SubmittedSurveyPage",
    component: SubmittedSurveyPage,
  },
  {
    path: "/survey-response/:surveyId/:surveyHash",
    name: "SurveyPage",
    component: SurveyPage,
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
